module.exports = __webpack_public_path__ + "img/Metallic_media_6x8.2ef83011.jpg";